import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from "vue-router";
import store from "@/store";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Login from "@/views/Login.vue";
import ShopIndex from "@/views/shop/Index.vue";
import WebsiteIndex from "@/views/website/Index.vue";

import ProductList from "@/views/shop/product/ProductList.vue";
import ProductDetail from "@/views/shop/product/ProductDetail.vue";
import ProductCategoryList from "@/views/shop/category/ProductCategoryList.vue";
import ProductCategoryDetail from "@/views/shop/category/ProductCategoryDetail.vue";
import OrderList from "@/views/shop/order/OrderList.vue";
import OrderDetail from "@/views/shop/order/OrderDetail.vue";

import CategoryList from "@/views/cms/category/CategoryList.vue";
import CategoryDetail from "@/views/cms/category/CategoryDetail.vue";
import ContentList from "@/views/cms/content/ContentList.vue";
import ContentDetail from "@/views/cms/content/ContentDetail.vue";
import TagList from "@/views/cms/tag/TagList.vue";
import TagDetail from "@/views/cms/tag/TagDetail.vue";
import TemplateList from "@/views/cms/template/TemplateList.vue";
import TemplateDetail from "@/views/cms/template/TemplateDetail.vue";

import ChargeList from "@/views/ins/charge/ChargeList.vue";
import ChargeDetail from "@/views/ins/charge/ChargeDetail.vue";
import DelegateList from "@/views/ins/delegate/DelegateList.vue";
import DelegateDetail from "@/views/ins/delegate/DelegateDetail.vue";
import InspectList from "@/views/ins/inspect/InspectList.vue";
import InspectDetail from "@/views/ins/inspect/InspectDetail.vue";

import AddressList from "@/views/user/address/AddressList.vue";
import AddressDetail from "@/views/user/address/AddressDetail.vue";
import AppUserList from "@/views/user/appuser/AppUserList.vue";
import AppUserDetail from "@/views/user/appuser/AppUserDetail.vue";
import InvoiceList from "@/views/user/invoice/InvoiceList.vue";
import InvoiceDetail from "@/views/user/invoice/InvoiceDetail.vue";

import AuthList from "@/views/system/auth/AuthList.vue";
import AuthDetail from "@/views/system/auth/AuthDetail.vue";
import ConfigList from "@/views/system/config/ConfigList.vue";
import ConfigDetail from "@/views/system/config/ConfigDetail.vue";
import SystemLogList from "@/views/system/log/SystemLogList.vue";
import SystemLogDetail from "@/views/system/log/SystemLogDetail.vue";
import MenuList from "@/views/system/menu/MenuList.vue";
import MenuDetail from "@/views/system/menu/MenuDetail.vue";
import UserList from "@/views/system/user/UserList.vue";
import UserDetail from "@/views/system/user/UserDetail.vue";
import CustomList from "@/views/system/custom/CustomList.vue";
import CustomDetail from "@/views/system/custom/CustomDetail.vue";
import TaskList from "@/views/system/task/TaskList.vue";
import TaskDetail from "@/views/system/task/TaskDetail.vue";

import WechatConfigList from "@/views/wechat/config/WechatConfigList.vue";
import WechatConfigDetail from "@/views/wechat/config/WechatConfigDetail.vue";
import WechatMenuList from "@/views/wechat/menu/WechatMenuList.vue";
import WechatMenuDetail from "@/views/wechat/menu/WechatMenuDetail.vue";
import MessageList from "@/views/wechat/message/MessageList.vue";
import MessageDetail from "@/views/wechat/message/MessageDetail.vue";
import MessageTemplateList from "@/views/wechat/template/MessageTemplateList.vue";
import MessageTemplateDetail from "@/views/wechat/template/MessageTemplateDetail.vue";
import WechatUserList from "@/views/wechat/user/WechatUserList.vue";
import WechatUserDetail from "@/views/wechat/user/WechatUserDetail.vue";
import { AppConfig } from "@/script/core/base/AppConfig";

import CameraList from "@/views/device/camera/CameraList.vue";
import CameraDetail from "@/views/device/camera/CameraDetail.vue";
import ServerList from "@/views/device/server/ServerList.vue";
import ServerDetail from "@/views/device/server/ServerDetail.vue";
import ClientList from "@/views/device/client/ClientList.vue";
import ClientDetail from "@/views/device/client/ClientDetail.vue";

import NodeList from "@/views/rec/node/NodeList.vue";
import NodeDetail from "@/views/rec/node/NodeDetail.vue";
import CruiseList from "@/views/rec/cruise/CruiseList.vue";
import CruiseDetail from "@/views/rec/cruise/CruiseDetail.vue";
import ReconList from "@/views/rec/recon/ReconReport.vue";
import ReconDetail from "@/views/rec/recon/ReconDetail.vue";
import WarnList from "@/views/rec/warn/WarnList.vue";
import WarnDetail from "@/views/rec/warn/WarnDetail.vue";

let router: Router;

class RouterFactory {
  public static init() {
    const routes: Array<RouteRecordRaw> = [
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { requiresAuth: false }
      },
      {
        path: "/about",
        name: "About",
        component: About,
        meta: { requiresAuth: true }
      },
      {
        path: "/",
        name: "Home",
        component: Home,
        meta: { requiresAuth: true },
        children: [
          RouterFactory.getIndexInfo(),
          {
            path: "/shop/product/list",
            name: "ProductList",
            component: ProductList,
            meta: { requiresAuth: true }
          },
          {
            path: "/shop/product/detail",
            name: "ProductDetail",
            component: ProductDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/shop/product_category/list",
            name: "ProductCategoryList",
            component: ProductCategoryList,
            meta: { requiresAuth: true }
          },
          {
            path: "/shop/product_category/detail",
            name: "ProductCategoryDetail",
            component: ProductCategoryDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/shop/order/list",
            name: "OrderList",
            component: OrderList,
            meta: { requiresAuth: true }
          },
          {
            path: "/shop/order/detail",
            name: "OrderDetail",
            component: OrderDetail,
            meta: { requiresAuth: true }
          },

          {
            path: "/cms/category/list",
            name: "CategoryList",
            component: CategoryList,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/category/detail",
            name: "CategoryDetail",
            component: CategoryDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/content/list",
            name: "ContentList",
            component: ContentList,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/content/detail",
            name: "ContentDetail",
            component: ContentDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/tag/list",
            name: "TagList",
            component: TagList,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/tag/detail",
            name: "TagDetail",
            component: TagDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/template/list",
            name: "TemplateList",
            component: TemplateList,
            meta: { requiresAuth: true }
          },
          {
            path: "/cms/template/detail",
            name: "TemplateDetail",
            component: TemplateDetail,
            meta: { requiresAuth: true }
          },

          {
            path: "/ins/charge/list",
            name: "ChargeList",
            component: ChargeList,
            meta: { requiresAuth: true }
          },
          {
            path: "/ins/charge/detail",
            name: "ChargeDetail",
            component: ChargeDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/ins/delegate/list",
            name: "DelegateList",
            component: DelegateList,
            meta: { requiresAuth: true }
          },
          {
            path: "/ins/delegate/detail",
            name: "DelegateDetail",
            component: DelegateDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/ins/inspect/list",
            name: "InspectList",
            component: InspectList,
            meta: { requiresAuth: true }
          },
          {
            path: "/ins/inspect/detail",
            name: "InspectDetail",
            component: InspectDetail,
            meta: { requiresAuth: true }
          },

          {
            path: "/user/address/list",
            name: "AddressList",
            component: AddressList,
            meta: { requiresAuth: true }
          },
          {
            path: "/user/address/detail",
            name: "AddressDetail",
            component: AddressDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/user/appuser/list",
            name: "AppUserList",
            component: AppUserList,
            meta: { requiresAuth: true }
          },
          {
            path: "/user/appuser/detail",
            name: "AppUserDetail",
            component: AppUserDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/user/invoice/list",
            name: "InvoiceList",
            component: InvoiceList,
            meta: { requiresAuth: true }
          },
          {
            path: "/user/invoice/detail",
            name: "InvoiceDetail",
            component: InvoiceDetail,
            meta: { requiresAuth: true }
          },

          {
            path: "/sys/auth/list",
            name: "AuthList",
            component: AuthList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/auth/detail",
            name: "AuthDetail",
            component: AuthDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/config/list",
            name: "ConfigList",
            component: ConfigList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/config/detail",
            name: "ConfigDetail",
            component: ConfigDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/system_log/list",
            name: "SystemLogList",
            component: SystemLogList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/system_log/detail",
            name: "SystemLogDetail",
            component: SystemLogDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/menu/list",
            name: "MenuList",
            component: MenuList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/menu/detail",
            name: "MenuDetail",
            component: MenuDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/user/list",
            name: "UserList",
            component: UserList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/user/detail",
            name: "UserDetail",
            component: UserDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/custom/list",
            name: "CustomList",
            component: CustomList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/custom/detail",
            name: "CustomDetail",
            component: CustomDetail,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/task/list",
            name: "TaskList",
            component: TaskList,
            meta: { requiresAuth: true }
          },
          {
            path: "/sys/task/detail",
            name: "TaskDetail",
            component: TaskDetail,
            meta: { requiresAuth: true }
          },

          {
            path: "/wechat/config/list",
            name: "WechatConfigList",
            component: WechatConfigList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/config/detail",
            name: "WechatConfigDetail",
            component: WechatConfigDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/menu/list",
            name: "WechatMenuList",
            component: WechatMenuList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/menu/detail",
            name: "WechatMenuDetail",
            component: WechatMenuDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/message/list",
            name: "MessageList",
            component: MessageList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/message/detail",
            name: "MessageDetail",
            component: MessageDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/template/list",
            name: "MessageTemplateList",
            component: MessageTemplateList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/template/detail",
            name: "MessageTemplateDetail",
            component: MessageTemplateDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/user/list",
            name: "WechatUserList",
            component: WechatUserList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/wechat/user/detail",
            name: "WechatUserDetail",
            component: WechatUserDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/camera/list",
            name: "CameraList",
            component: CameraList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/camera/detail",
            name: "CameraDetail",
            component: CameraDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/server/list",
            name: "ServerList",
            component: ServerList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/server/detail",
            name: "ServerDetail",
            component: ServerDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/client/list",
            name: "ClientList",
            component: ClientList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/device/client/detail",
            name: "ClientDetail",
            component: ClientDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/node/list",
            name: "NodeList",
            component: NodeList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/node/detail",
            name: "NodeDetail",
            component: NodeDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/cruise/list",
            name: "CruiseList",
            component: CruiseList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/cruise/detail",
            name: "CruiseLDetail",
            component: CruiseDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/recon/list",
            name: "ReconList",
            component: ReconList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/recon/detail",
            name: "ReconDetail",
            component: ReconDetail,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/warn/list",
            name: "WarnList",
            component: WarnList,
            meta: { requiresWechatConfig: true }
          },
          {
            path: "/rec/warn/detail",
            name: "WarnDetail",
            component: WarnDetail,
            meta: { requiresWechatConfig: true }
          }
        ]
      }
    ];

    router = createRouter({
      history: createWebHashHistory(),
      routes
    });

    router.beforeEach((to, from, next) => {
      //  检查是否需要控制权限
      if (to.meta.requiresAuth) {
        //  是否已登录
        if (store.getters.loginState === 0) {
          next({ name: "Login" });
        } else {
          next();
        }
      } else {
        next();
      }
    });
  }

  static getIndexInfo() {
    if (AppConfig.Config.AppName === "jd-website") {
      return {
        path: "/index",
        name: "Index",
        component: WebsiteIndex,
        meta: { requiresAuth: true }
      };
    } else if (AppConfig.Config.AppName === "jd-china") {
      return {
        path: "/index",
        name: "Index",
        component: WebsiteIndex,
        meta: { requiresAuth: true }
      };
    } else {
      return {
        path: "/index",
        name: "Index",
        component: ShopIndex,
        meta: { requiresAuth: true }
      };
    }
  }
}

export { RouterFactory, router };
